/*
 *
 * VolunteerTags reducer
 *
 */
import { createSlice } from '@reduxjs/toolkit';

import {
  createVolunteerTagsAct,
  createVolunteerTagsError,
  createVolunteerTagsSuccess,
  deleteVolunteerTagsAct,
  deleteVolunteerTagsError,
  deleteVolunteerTagsSuccess,
  getVolunteerTagsList,
  getVolunteerTagsListError,
  getVolunteerTagsListSuccess,
  resetGetVolunteerTagsList,
  updateActionStatusAct,
  updateVolunteerTagsAct,
  updateVolunteerTagsError,
  updateVolunteerTagsSuccess,
} from './actions';

import notesEntityAdapter from './entity-adapter';

export const initialState = notesEntityAdapter.getInitialState({
  loadingState: 0,
  error: '',
  totalPages: 0,
  count: 0,
  actionStatus: {
    status: 0,
    type: null,
    id: null,
  },
});

/* eslint-disable default-case, no-param-reassign */
const volunteerTagsSlice = createSlice({
  name: 'VolunteerTags',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getVolunteerTagsList, (state, { payload }) => {
        state.loadingState = 1;
        state.error = '';
        if (payload.params && payload.params.page === 1) {
          notesEntityAdapter.removeAll(state);
        }
      })
      .addCase(getVolunteerTagsListError, (state, { payload }) => {
        state.loadingState = 3;
        state.error = payload;
      })
      .addCase(getVolunteerTagsListSuccess, (state, { payload }) => {
        state.loadingState = 2;
        state.error = '';
        notesEntityAdapter.upsertMany(state, payload.rows);
        state.totalPages = payload.totalPages;
        state.count = payload.count;
      })
      .addCase(deleteVolunteerTagsAct, state => {
        state.actionStatus.status = 1;
      })
      .addCase(deleteVolunteerTagsError, state => {
        state.actionStatus.status = 3;
      })
      .addCase(deleteVolunteerTagsSuccess, (state, { payload }) => {
        const { id } = payload;
        state.actionStatus.status = 2;
        notesEntityAdapter.removeOne(state, id);
      })
      .addCase(updateVolunteerTagsAct, state => {
        state.actionStatus.status = 1;
      })
      .addCase(updateVolunteerTagsError, state => {
        state.actionStatus.status = 3;
      })
      .addCase(updateVolunteerTagsSuccess, (state, { payload }) => {
        const { id, name, updatedAt } = payload;
        state.actionStatus.status = 2;
        if (id && state.entities[id]) {
          notesEntityAdapter.updateOne(state, {
            id,
            changes: {
              name,
              updatedAt,
            },
          });
        }
      })
      .addCase(createVolunteerTagsAct, state => {
        state.actionStatus.status = 1;
      })
      .addCase(createVolunteerTagsError, state => {
        state.actionStatus.status = 3;
      })
      .addCase(createVolunteerTagsSuccess, (state, { payload }) => {
        state.actionStatus.status = 2;
        notesEntityAdapter.addOne(state, payload);
      })
      .addCase(updateActionStatusAct, (state, { payload }) => {
        state.actionStatus = payload;
      })
      .addCase(resetGetVolunteerTagsList, () => initialState);
  },
});

export default volunteerTagsSlice.reducer;
